import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/app/components/Main.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LiveAPIProvider"] */ "/workspace/src/context/LiveAPIContext.tsx");
